
<template>
  <div>
    <div class="searchBox" style="margin-bottom:10px;display: flex;">
      <div>
        <el-select  v-model="countryCode" filterable remote :remote-method="queryProvinces" placeholder="请选择贸易伙伴Please select a Trading Partner"
            clearable @visible-change="visibleChange" @visible="handleVisible" @change="selectChange" class="custom-select custom-select-background"
            :popper-append-to-body='false'>
            <div class="alphabet-column">
                <div v-for="letter in letters" :key="letter" @click="scrollToProvince(letter)">
                    {{ letter }}
                </div>
            </div>
            <el-option-group v-for="(group, index) in sortedProvinceGroups" :key="index" :label="group.letter">
                <el-option v-for="province in group.provinces" :key="province.countryCode" :label="province.countryName"
                    :value="province.countryCode" :ref="`provinceOption-${province.countryCode}`"></el-option>
            </el-option-group>

        </el-select>

       <!-- <el-select v-model="countryCode" @change="selectChange" :popper-append-to-body="false" clearable filterable placeholder="请选择贸易伙伴Please select a Trading Partner" class="custom-select-background">
          <el-option
            v-for="item in nationList"
            :key="item.countryCode"
            :label="item.countryName"
            :value="item.countryCode">
          </el-option>
        </el-select> -->

       <el-select v-model="area" @change="selectChange" clearable :popper-append-to-body="false" filterable placeholder="请选择地区" class="custom-select-background" v-if="countryCode=='CHN'">
          <el-option
            v-for="item in areaList"
            :key="item.countryCode"
            :label="item.countryName"
            :value="item.countryCode">
          </el-option>
        </el-select>

      </div>
    </div>
    <div class="boxbg boxbg10" style="height: 100%;">
      <div class="boxTitle">AEO与{{countryName}}贸易概况(全国海关)</div>
      <div class="boxTitle1" v-if="countryName=='贸易伙伴'">Overview of AEO Trade Volume with  Trading Partners</div>
      <div class="boxTitle1" v-else>Overview of AEO Trade Volume with {{countryCode}}</div>
      <div class="echart">
        <div id="echart27" style="height:200px;width: 100%;"></div>
      </div>
    </div>

  </div>

</template>

<script>
  import * as echarts from 'echarts';
  import common from '../../components/api';
	export default {
		name: "eight",
		data() {
      return {
        Chart:null,
        option:{},
        customCode:'',

        nationList:[],//国家
        countryCode:'',//国家code
        countryName:'贸易伙伴',
        areaList:[{countryCode:"HKG",countryName:"中国香港"},{countryCode:"MAC",countryName:"中国澳门"},{countryCode:"TWN",countryName:"中国台湾"}],
        area:'',


        selectedProvince: '', // 绑定选中的省份
        selectedLetter: '',
        provinces: [],
        letters: [] // 字母数组

      }
		},
    mounted() {
     this.dataInfo1('');
     this.getSelect();
    },
    computed: {
        sortedProvinceGroups() {
            // 如果没有选择字母，则返回所有省份分组
            if (!this.selectedLetter) {
                // 根据首字母对省份数据进行分组和排序
                // const sortedProvinces = this.provinces.sort((a, b) => a.letter.localeCompare(b.letter));
                // const groups = {};
                // sortedProvinces.forEach(province => {
                //     const letter = province.letter;
                //     if (!groups[letter]) {
                //         groups[letter] = [];
                //     }
                //     groups[letter].push(province);
                // });
                // let re = Object.keys(groups).map(letter => ({ letter, provinces: groups[letter] }));
                // console.log(re,'re')
                return this.provinces;
            }

            // 只返回选定字母对应的省份组
            let res = this.provinces
                .filter(province => province.letter === this.selectedLetter)
                .map(province => ({ letter:this.selectedLetter,provinces: province.provinces }));
                console.log(res,'res')
            return res;
        }
    },
    methods:{
      // 点击字母滚动到对应省份位置
      scrollToProvince(letter) {
          this.selectedLetter = letter;
          console.log(letter)
          const targetProvince = this.provinces.find(province => province.letter === letter);
          if (targetProvince) {
              // const targetRef = this.$refs[`provinceOption-${targetProvince.id}`]; // 获取对应的 ref
              // if (targetRef) {
              //     console.log(targetRef, 'ref')
              //     targetRef.$el.scrollIntoView();
              // }
          }
      },
      // 远程搜索函数
      queryProvinces(query) {
          // 模拟异步请求，实际中应该发送请求到后端进行检索
          setTimeout(() => {
              // 根据输入内容查询匹配的省份
              const matchedProvinces = this.provinces.filter(province => province.name.includes(query));
              // 将查询结果传递给 el-select 组件
              this.provinces = matchedProvinces;
          }, 300); // 模拟延迟
      },
      // 处理下拉框显示事件
      handleVisible(visible) {
          if (visible) {
              // 下拉框显示时，滚动到第一个省份
              this.$nextTick(() => {
                  const firstProvince = this.provinces[0];
                  if (firstProvince) {
                      const targetRef = this.$refs[`provinceOption-${firstProvince.id}`]; // 获取对应的 ref
                      if (targetRef) {
                          targetRef.$el.scrollIntoView();
                      }
                  }
              });
          }
      },
      // 处理下拉框显示/隐藏变化事件
      visibleChange(visible) {
          if (!visible) {
              // 下拉框隐藏时，重置搜索条件
              // 这里你可以根据需要进行其他操作，比如清空搜索框内容等
              this.selectedLetter = "";
          }
      },
      selectChange(){
        let code = '';
        if(this.countryCode=='CHN' && !this.area){
          code = 'CHN';
          this.countryName = '中国'
        }else if(this.countryCode=='CHN' && this.area){
          code = this.area;
          if(this.area=='HKG'){
            this.countryName = '中国香港'
          }else if(this.area=='MAC'){
            this.countryName = '中国澳门'
          }else if(this.area=='TWN'){
            this.countryName = '中国台湾'
          }
        }else{
          code = this.countryCode;
          if(this.countryCode){
            let obj = this.provinces;
            for(let key in obj){
              for(let i=0;i<obj[key].provinces.length;i++){
                if(this.countryCode==obj[key].provinces[i].countryCode){
                  this.countryName = obj[key].provinces[i].countryName;
                   break;
                }
              }
            }
          }else{
            this.countryName = '所有国家'
          }
        }
        this.dataInfo1(code);
      },
      getSelect(){
        //获取国家
        this.$axios.post(common.apihost+'/aeo/tradeData/getCustomCountryInitial').then(res =>{
            //this.nationList = res.data.data;
            let data = res.data.data;
            let provinces = [];
            let letters = [];
            for (let key in data) {
              letters.push(key)
              provinces.push({letter:key,provinces:data[key]})
            }
            this.letters = letters;
            this.provinces = provinces;
        })
      },
      numbertoFixed(res){
        let data = (Number(res) / 100000000).toFixed(2);
        return data;
      },
      dataInfo1(code){
        //左边底部折现图
        this.$axios.post(common.apihost+'/aeo/tradeData/getYearAmount',{
           countryCode:code
        }).then(res =>{
          let data = res.data.data;
          let totalYearAmountList = [this.numbertoFixed(data.totalYearAmountList[0].aeoTotalAmount),this.numbertoFixed(data.totalYearAmountList[1].aeoTotalAmount),this.numbertoFixed(data.totalYearAmountList[2].aeoTotalAmount)];
          let iyearAmountList = [this.numbertoFixed(data.iyearAmountList[0].aeoTotalAmount),this.numbertoFixed(data.iyearAmountList[1].aeoTotalAmount),this.numbertoFixed(data.iyearAmountList[2].aeoTotalAmount)];
          let eyearAmountList = [this.numbertoFixed(data.eyearAmountList[0].aeoTotalAmount),this.numbertoFixed(data.eyearAmountList[1].aeoTotalAmount),this.numbertoFixed(data.eyearAmountList[2].aeoTotalAmount)];


          this.echartInfo(totalYearAmountList,iyearAmountList,eyearAmountList);
        })
      },
      echartInfo(arr1,arr2,arr3){
        this.Chart = this.$echarts.init(document.getElementById('echart27'));
        this.option = {
          tooltip: {
            trigger: 'axis',
          },
          color: ['#0078ff', '#00ffcc','#5470C6'],
          legend: {
            data: [
              {
                name: '进出口贸易额',
                icon: 'circle', // 图例的图标样式

              },
              // {
              //   name: '进口贸易额',
              //   icon: 'circle',
              // },
              // {
              //   name: '出口贸易额',
              //   icon: 'circle',
              // },
            ],
            top: '0%',
            right: '0%',
            textStyle: { //图例的文字样式
              color: '#fff',
              fontSize:17
            },
          },
          grid: {
            x: 90,
            y: 35,
            x2: 80,
            y2: 35
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            data: ['2021','2022','2023'],

            // 轴线的字体样式
            axisLabel: {
              show: false,
              textStyle: {
                color: '#fff',
                fontSize: '16',
                // fontSize: 16, 可直接写数字,单位px
              },
            },
            // 轴线的样式
            axisLine: {
              lineStyle: {
                color: '#273169',
              },
            },
            // 网格线样式
            splitLine: {
              show: false,
              lineStyle: {
                color: ['#273169'],
              },
            },
            axisLine: {//坐标轴轴线
            				show: false
            			},

          },
          yAxis: {
            type: 'value',
            name: '亿', // y轴的单位,不写就没有
            nameTextStyle: { //单位'个'的样式
              color: '#fff',
            },
            axisTick: {//坐标轴刻度
            	show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: '16',
              },
            },
            axisLine: {
              lineStyle: {
                color: '#273169',
              },
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: ['#273169'],
              },
            },
          },
          series: [
            {
              name: '进出口贸易额',
              type: 'line',
              stack:"进出口贸易额",
               data: arr1,
               z: 1,
                itemStyle : { normal: {label : {
                  show: true,color: '#fff',fontSize:18,
                 },
                },
               },
              areaStyle: { // 要加这个属性,折线与下方的区域才能填充颜色
                color: { // 这边是设置渐变色,好看一点
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(0,156,255,0.5)',
                    },
                    {
                      offset: 0.5, //这是于下方线的距离,设置1就不留空隙
                      color: 'rgba(0,156,255,0)',
                    },
                  ],
                  global: false,
                },
              },
            },
            // {
            //   name: '进口贸易额',
            //   type: 'line',
            //   stack:"进口贸易额",
            //   itemStyle : { normal: {label : {show: true,color: '#fff',fontSize:18, position: 'bottom',}}},
            //   data: arr2,
            //   z: 1,
            //   areaStyle: {
            //     color: {
            //       type: 'linear',
            //       x: 0,
            //       y: 0,
            //       x2: 0,
            //       y2: 1,
            //       colorStops: [
            //         {
            //           offset: 0,
            //           color: 'rgba(0,255,133,0.5)',
            //         },
            //         {
            //           offset: 0.9,
            //           color: 'rgba(0,255,133,0)',
            //         },
            //       ],
            //       global: false,
            //     },
            //   },
            // },
            // {
            //   name: '出口贸易额',
            //   type: 'line',
            //   stack:'出口贸易额',
            //   itemStyle : { normal: {label : {show: true, color: '#fff',fontSize:18, position: 'top',}}},
            //   data: arr3,
            //   z: 1,
            //   areaStyle: {
            //     color: {
            //       type: 'linear',
            //       x: 0,
            //       y: 0,
            //       x2: 0,
            //       y2: 1,
            //       colorStops: [
            //         {
            //           offset: 0,
            //           color: 'rgba(84,112,198,0.5)',
            //         },
            //         {
            //           offset: 0.9,
            //           color: 'rgba(84,112,198,0)',
            //         },
            //       ],
            //       global: false,
            //     },
            //   },
            // }
          ],
        };

        this.Chart.setOption(this.option);

      },
    }
	}

</script>

<style scoped>

  .custom-select .el-input__inner {

      padding-right: 30px;
      /* 增加右侧间距 */
  }
  .custom-select /deep/ .el-select-dropdown{
    height: 1000px;
  }
  .custom-select /deep/ .el-select-dropdown .el-scrollbar{
    height: 1000px;
  }
  .custom-select /deep/ .el-select-dropdown .el-select-dropdown__wrap{
    max-height: 1000px;
    overflow-x: auto;
  }
  .custom-select /deep/ .el-select-group__title{
    font-size:22px;
    font-weight: bold;
    text-align:left;
  }
  .custom-select /deep/ .el-select-dropdown__item{
    text-align:left;
  }

  .alphabet-column {
      display: flex;
      flex-direction: column;
      position: absolute;
      right: 5px;
      /* 调整位置 */
      top: 0;
      bottom: 0;
      padding-top: 10px;
      /* 调整上下内边距 */
      pointer-events: none;
      /* 不影响下拉框的点击事件 */
      z-index: 1;
      /* 设置 z-index，确保在选项之上 */
      font-size: 10px;

  }

  .alphabet-column div {
      cursor: pointer;
      padding: 6px 8px;
      pointer-events: auto;
      font-size:28px;
      font-weight: bold;
      /* 恢复点击事件 */
  }

  /deep/.el-select-dropdown__wrap {
      min-height: 280px !important;
      text-align: start;
  }

  /* 调整选项的样式，确保不遮挡右侧字母列 */
  .el-select-dropdown .el-scrollbar__wrap {
      overflow: visible !important;
  }

  .el-select-dropdown .el-option {
      overflow: visible !important;
  }

  .el-select-dropdown .el-option__content {
      overflow: visible !important;
  }

  .el-select-dropdown .el-option__content:hover {
      background-color: transparent !important;
      /* 鼠标悬停时取消背景色 */
  }



  .boxTitle{
    width: 100%;
  }
  .searchBox /deep/ .el-select-dropdown{
    z-index: 1000000!important;
    top:-1003px!important;

  }
  .searchBox /deep/ .el-scrollbar{
     z-index: 1000000!important;

  }
  .searchBox /deep/ .el-select-dropdown .el-select-dropdown__item span{
    font-size: 24px!important;
    font-weight: bold;
  }
  .searchBox /deep/ .el-select-dropdown .el-select-dropdown__item{
        height: 44px;
        line-height: 44px;
  }
  .searchBox /deep/ .custom-select-background  .el-input__inner {
    background-color: rgba(57, 161, 251, 0.1);
    border:1px solid rgba(57, 161, 251, 0.1);
    width: 350px;
    color:#ddd;
  }
  select{
    background-color: rgba(57, 161, 251, 0.1);
    border:1px solid rgba(57, 161, 251, 0.1);
    color:#0CB2E0;
    width:180px;
    height:35px;
    margin-top:10px;
    margin-right:10px;
  }
  .totalText{
    font-size: 20px;
    color:#1AC7FD;
    font-family: '微软雅黑';
        font-weight: 400;
  }

  .rightNumber{
    display: flex;
    align-items: center;
    font-family: '微软雅黑';
    font-weight: 400;
    justify-content: center;
  }
  .imgBox{
    width: 70px;
    height: 70px;
    background: inherit;
    background-color: rgba(255, 255, 255, 0);
    box-sizing: border-box;
    border-width: 4px;
    border-style: solid;
    border-color: rgba(49, 167, 255, 1);
    border-radius: 188px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: '微软雅黑';
    font-weight: 400;
    font-style: normal;
    color: #FFFFFF;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .imgBox img{
    width: 42px;
    height: 42px;
  }
  .numberText{
    border-width: 0px;
    width: 280px;
    height: 100px;
    background: inherit;
    background-color: rgba(26, 201, 255, 0.298039215686275);
    border: none;
    border-top: 0px;
    border-right: 0px;
    border-bottom: 0px;
    border-radius: 0px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: '微软雅黑';
    font-weight: 400;
    font-style: normal;
    text-align: left;
    margin-left:15px;
    padding:15px 20px;
  }
  .boxbg10{
    /* background-color: rgba(134, 79, 211, 0.23); */
    background-color: rgba(248, 227, 122, 0.6);
  }
</style>



// WEBPACK FOOTER //
// src/components/leftNew/bottom.vue